import type { EditedBy } from "./payload";

// Row order top-to-bottom / left-to-right on the matrix.
export const RISK_IMPACTS = ["catastrophic", "critical", "considerable", "significant", "minor", "negligible"] as const;
export const RISK_LIKELIHOODS = ["very_unlikely", "unlikely", "possible", "likely", "very_likely"] as const;

export type RiskImpact = (typeof RISK_IMPACTS)[number];
export type RiskLikelihood = (typeof RISK_LIKELIHOODS)[number];

// Matches the risk_matrix_cell Postgres enum (supabase/sql/014_mission_risks.sql):
// one value per matrix cell, e.g. "catastrophic__very_unlikely".
export type RiskMatrixCell = `${RiskImpact}__${RiskLikelihood}`;

export function makeCellId(impact: RiskImpact, likelihood: RiskLikelihood): RiskMatrixCell {
  return `${impact}__${likelihood}`;
}

export type MissionRiskRow = {
  id: string;
  group_id: string;
  risk_code: string;
  description: string;
  matrix_cell: RiskMatrixCell | null;
  order_index: number;
  edited_by?: EditedBy | null;
};

// One mitigation entry for a risk sitting in the red ("Very High") zone.
// is_auto rows are created/removed automatically as a risk enters/leaves
// the red zone and can't be deleted from the UI; manually added rows
// (is_auto = false) can be.
export type MissionMitigationRow = {
  id: string;
  risk_id: string;
  mitigation: string;
  is_auto: boolean;
  order_index: number;
  edited_by?: EditedBy | null;
};
